import styled from 'styled-components';

export const WrapperContainer = styled.section`
  background-color: var(--BackgroundColor);
`;
